// R54.2 — L'app è ora esclusivamente Ristorazione (rimosso variant PMI legacy).
// Le costanti IS_RISTORAZIONE / APP_VARIANT restano esposte per retrocompat
// con i componenti che le importano; il ternario nei call site è sempre `true`.
export const APP_VARIANT = "ristorazione";
export const IS_RISTORAZIONE = true;


/**
 * R52.18 — Helper piano variante Ristorazione.
 * `user.ristorazione_plan` è esposto da /auth/me: "base" | "plus" | "executive".
 * R60.12: introdotto piano Executive (Plus + Ricette/Magazzino/Costi).
 */
export function getPlan(user) {
  if (!user || !IS_RISTORAZIONE) return null;
  return (user.ristorazione_plan || "base").toLowerCase();
}
export function isPlus(user) {
  const p = getPlan(user);
  return p === "plus" || p === "executive";
}
export function isExecutive(user) {
  return getPlan(user) === "executive";
}

// R60.60 — Nuovo listino SaaS annuale (2 piani puri). Executive legacy grandfathered.
export const PLAN_LABELS = {
  base: { label: "Base", price: "299 €/anno + IVA" },
  plus: { label: "Plus", price: "499 €/anno + IVA" },
  executive: { label: "Plus (legacy)", price: "450 €/anno + IVA" },
};

/** Moduli inclusi solo nel piano Plus (hard gate R60.60). */
export const PLUS_ONLY_MODULES = ["ricette", "magazzino", "costi"];

/** True se l'utente ha accesso ai moduli Plus-only (Plus o Executive legacy). */
export function hasPlusModules(user) {
  const p = getPlan(user);
  return p === "plus" || p === "executive";
}

export function planLabel(user) {
  const p = getPlan(user) || "base";
  return PLAN_LABELS[p] || PLAN_LABELS.base;
}
